var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100vh"},[(_vm.loading)?_c('div',{staticClass:"loading-meet-room"},[_c('span',{staticClass:"spinner-border spinner-border-sm mr-2",attrs:{"role":"status"}})]):_vm._e(),(!_vm.loading && _vm.email)?_c('div',[_c('OTPLoginCpn',{attrs:{"prop_email":_vm.email},on:{"logged":_vm.logged,"changeOtp":o => {
          _vm.otp = o
        }}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }